/**
 * Constants
 * */
export const moduleName = `licenseeStore`;

/**
 * Reducer
 * */

export default function reducer(state = false, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const licenseeStoreSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
